import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const flyIo = defineConnector({
  identifier: "flyIo",
  name: "Fly.io",
  tagLine: "Global app deployment platform",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://api\\.fly\\.io/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your Fly.io access token",
      items: [
        {
          kind: "markdown",
          content:
            "In your Fly.io dashboard, go to **Account > Access Tokens** and create a new token, or use the CLI with `fly tokens create`.",
        },
      ],
    },
    {
      title: "Enter your access token",
      items: [
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.fly.io/graphql",
  },
});
